/**
 * Enumeration used to reflect different drawing modes in the
 * smart whiteboard.
 */
export enum DrawingMode {
  PENCIL,
  LINE,
  RECTANGLE,
  ELLIPSE,
  SELECTION,
  TEXT,
  UML,
  UML_DIAMOND,
  SHAPE_PHONE,
  SHAPE_TABLET,
  SHAPE_DESKTOP
}
